import { initFindYourLocationModal } from './find-your-location';
import { initLanguageModal } from './language-modal';
import { initPromoBannerModal } from './promo-banner';

export const initModals = () =>
{
	initFindYourLocationModal();
	initPromoBannerModal();
	initLanguageModal();
}



// WEBPACK FOOTER //
// ./scripts/modules/modals.js